module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai775-5b819325ccacfadb96695dc0a17cbea6.jpg";